// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__WQcch","noInteraction":"EventWrapper_noInteraction__1WkRs"};